class TrLoadMore extends HTMLElement {
	selectors = {
		button: '[data-tr-js-load-more-button]',
		item: '[data-tr-js-load-more-item]',
	}

	attributes = {
		expandedText: 'data-expanded-text',
		collapsedText: 'data-collapsed-text',
		visibleCount: 'data-visible-count',
	}

	stateClasses = {
		isHidden: 'tr-load-more__item--hidden',
	}

	connectedCallback() {
		this.buttonElement = this.querySelector(this.selectors.button)
		this.itemElements = Array.from(this.querySelectorAll(this.selectors.item))

		this.init()
		this.bindEvents()
		document.addEventListener('shopify:section:load', this.onSectionLoad)
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad)
		this.destroy()
	}

	init() {
		this.visibleCount = Number(this.getAttribute(this.attributes.visibleCount)) || 0
		this.isExpanded = false
		this.collapsedText = this.buttonElement?.getAttribute(this.attributes.collapsedText) || ''
		this.expandedText = this.buttonElement?.getAttribute(this.attributes.expandedText) || this.collapsedText

		this.updateItems()
		this.updateButton()

		if (this.buttonElement && this.itemElements.length <= this.visibleCount) {
			this.buttonElement.hidden = true
		}
	}

	bindEvents() {
		if (!this.buttonElement) return

		this.buttonElement.addEventListener('click', this.onButtonClick)
	}

	onSectionLoad = (event) => {
		if (!this.closest(`#shopify-section-${event.detail.sectionId}`)) return

		this.destroy()
		this.buttonElement = this.querySelector(this.selectors.button)
		this.itemElements = Array.from(this.querySelectorAll(this.selectors.item))
		this.init()
		this.bindEvents()
	}

	onButtonClick = () => {
		this.isExpanded = !this.isExpanded
		this.updateItems()
		this.updateButton()
	}

	updateItems() {
		this.itemElements.forEach((itemElement, itemIndex) => {
			const shouldHideItem = !this.isExpanded && itemIndex >= this.visibleCount

			itemElement.classList.toggle(this.stateClasses.isHidden, shouldHideItem)
		})
	}

	updateButton() {
		if (!this.buttonElement) return

		this.buttonElement.textContent = this.isExpanded ? this.expandedText : this.collapsedText
		this.buttonElement.setAttribute('aria-expanded', String(this.isExpanded))
	}

	destroy() {
		if (!this.buttonElement) return

		this.buttonElement.removeEventListener('click', this.onButtonClick)
	}
}

if (!customElements.get('tr-load-more')) {
	customElements.define('tr-load-more', TrLoadMore)
}
